import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  // Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddTemplatesAction,
  UpdateTemplatesAction,
} from "store/middlewares/dataManagement/messageTemplate";
import { InputTextarea, SubmitLoaderButton } from "components/atoms";

function ModalEditFollowUpTemplate({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  const handleSubmit = (values) => {
    let tempObj = { ...values, title: values.title.trim() };

    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,onSuccess: () => formik.setSubmitting(false),
    onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    },
      };
      dispatch(UpdateTemplatesAction(tempObj));
    } else {
      dispatch(AddTemplatesAction(tempObj));
    }
  };

  const formik = useFormik({
    initialValues: {
      title: row?.title ? row?.title : "",
      content: row?.content ? row?.content : "",
      type: "followUp",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .min(3, "Minimum 3 characters required"),
      content: Yup.string()
        .required("Content is required")
        .min(3, "Minimum 3 characters required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Follow Up Templates</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title</Label>
              <Input
                error={formik.errors.title && formik.touched.title}
                errorMsg={formik.errors.title}
                value={formik.values.title}
                type="text"
                name="title"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter title"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>
            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32 mt-4">Content</Label>
              <InputTextarea
                error={formik.errors.content && formik.touched.content}
                errorMsg={formik.errors.content}
                value={formik.values.content}
                type="text"
                name="content"
                isSpace={true}
                isRequired={false}
                onChange={(e) => {
                  if (e.target.value.length <= 150) {
                    formik.handleChange(e);
                  }
                }}
                onBlur={formik.handleBlur}
                placeholder="Enter content"
                maxLength={150}
              />
            </div>

            <div className="flex justify-center">
              {/* <Button type={"submit"}>{row ? "Update" : "Add"}</Button> */}
            <SubmitLoaderButton
                 btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}      
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditFollowUpTemplate;
